const img = (slug) => `/assets/products/${slug}.jpg`;

export const CATEGORIES = [
  {
    slug: "whole-spices",
    name: "Whole Spices",
    image: img("fennel-seeds"),
    description:
      "Dill, fennel, fenugreek, cinnamon, ajwain, cardamom, curry leaves, coriander seeds and mace.",
  },
  {
    slug: "powder-spices",
    name: "Powder Spices",
    image: img("turmeric-powder"),
    description:
      "Turmeric, coriander, chilli, cumin, curry, garam masala, garlic, ginger and cardamom powders.",
  },
  {
    slug: "superfoods",
    name: "Superfoods & Healthy Snacks",
    image: img("makhana"),
    description:
      "Makhana, roasted chana, almonds, cashews, raisins, pumpkin, sunflower and flax seeds.",
  },
  {
    slug: "ready-to-eat",
    name: "Ready-to-Eat Indian Meals",
    image: img("rte-palak-paneer"),
    description:
      "Authentic Indian meals in export-ready 300g / 250g packs — private label available.",
  },
  {
    slug: "mango-pulp",
    name: "Mango Pulp",
    image: img("kesar-mango-pulp"),
    description: "Kesar and Alphonso mango pulp in export-ready packaging.",
  },
  {
    slug: "cooking-pastes",
    name: "Cooking Pastes",
    image: img("ginger-garlic-paste"),
    description: "Ginger garlic, garlic and ginger pastes for retail and food service.",
  },
  {
    slug: "pickles",
    name: "Pickles",
    image: img("sweet-mango-pickle"),
    description:
      "Nine authentic Indian varieties — mango, lime, chilli, kerda, gunda, garlic and more.",
  },
  {
    slug: "fruit-jams",
    name: "Fruit Jams",
    image: img("strawberry-jam"),
    description:
      "Eight fruit varieties — mixed fruit, strawberry, apricot, raspberry, orange, mango and more.",
  },
  {
    slug: "other-fmcg",
    name: "Other Food & FMCG Products",
    image: "/assets/brand/private-label.jpg",
    description:
      "Additional supermarket-ready food and FMCG products available through RBL EXIM.",
  },
];

export const CATEGORY_LABELS = Object.fromEntries(
  CATEGORIES.map((c) => [c.slug, c.name])
);

const P = (name, slug, category, pack, brand) => ({
  name,
  slug,
  category,
  categoryLabel: CATEGORY_LABELS[category],
  image: img(slug),
  ...(pack ? { pack } : {}),
  ...(brand ? { brand } : {}),
});

export const PRODUCTS = [
  P("Dill Seeds", "dill-seeds", "whole-spices"),
  P("Fennel Seeds", "fennel-seeds", "whole-spices"),
  P("Fenugreek Seeds", "fenugreek-seeds", "whole-spices"),
  P("Cinnamon Stick", "cinnamon-stick", "whole-spices"),
  P("Ajwain Seeds", "ajwain-seeds", "whole-spices"),
  P("Cardamom", "cardamom", "whole-spices"),
  P("Curry Leaves", "curry-leaves", "whole-spices"),
  P("Coriander Seeds", "coriander-seeds", "whole-spices"),
  P("Mace (Javitri)", "mace-javitri", "whole-spices"),
  P("Turmeric Powder", "turmeric-powder", "powder-spices"),
  P("Coriander Powder", "coriander-powder", "powder-spices"),
  P("Chilli Powder", "chilli-powder", "powder-spices"),
  P("Cumin Powder", "cumin-powder", "powder-spices"),
  P("Curry Powder", "curry-powder", "powder-spices"),
  P("Garam Masala Powder", "garam-masala-powder", "powder-spices"),
  P("Garlic Powder", "garlic-powder", "powder-spices"),
  P("Ginger Powder", "ginger-powder", "powder-spices"),
  P("Cardamom Powder", "cardamom-powder", "powder-spices"),
  P("Makhana", "makhana", "superfoods"),
  P("Roasted Chana", "roasted-chana", "superfoods"),
  P("Almonds", "almonds", "superfoods"),
  P("Cashews", "cashews", "superfoods"),
  P("Raisins", "raisins", "superfoods"),
  P("Pumpkin Seeds", "pumpkin-seeds", "superfoods"),
  P("Sunflower Seeds", "sunflower-seeds", "superfoods"),
  P("Flax Seeds", "flax-seeds", "superfoods"),
  P("Masala Khichdi", "rte-masala-khichdi", "ready-to-eat", "300g"),
  P("Methi Malai Mutter", "rte-methi-malai-mutter", "ready-to-eat", "300g"),
  P("Palak Paneer", "rte-palak-paneer", "ready-to-eat", "300g"),
  P("Paneer Makhani", "rte-paneer-makhani", "ready-to-eat", "300g"),
  P("Paneer Butter Masala", "rte-paneer-butter-masala", "ready-to-eat", "300g"),
  P("Mutter Paneer", "rte-mutter-paneer", "ready-to-eat", "300g"),
  P("Cumin Rice", "rte-cumin-rice", "ready-to-eat", "250g"),
  P("Vegetable Biryani", "rte-vegetable-biryani", "ready-to-eat", "250g"),
  P("Pav Bhaji", "rte-pav-bhaji", "ready-to-eat", "300g"),
  P("Kadhi Pakoda", "rte-kadhi-pakoda", "ready-to-eat", "300g"),
  P("Gujarati Dal", "rte-gujarati-dal", "ready-to-eat", "300g"),
  P("Amritsari Chole", "rte-amritsari-chole", "ready-to-eat", "300g"),
  P("Undhiyu", "rte-undhiyu", "ready-to-eat", "300g"),
  P("Aloo Mutter", "rte-aloo-mutter", "ready-to-eat", "300g"),
  P("Baingan Bhartha", "rte-baingan-bhartha", "ready-to-eat", "300g"),
  P("Bhindi Masala", "rte-bhindi-masala", "ready-to-eat", "300g"),
  P("Chana Masala", "rte-chana-masala", "ready-to-eat", "300g"),
  P("Dal Tadka", "rte-dal-tadka", "ready-to-eat", "300g"),
  P("Dal Makhani", "rte-dal-makhani", "ready-to-eat", "300g"),
  P("Rajma Masala", "rte-rajma-masala", "ready-to-eat", "300g"),
  P("Kesar Mango Pulp", "kesar-mango-pulp", "mango-pulp"),
  P("Alphonso Mango Pulp", "alphonso-mango-pulp", "mango-pulp"),
  P("Ginger Garlic Paste", "ginger-garlic-paste", "cooking-pastes"),
  P("Garlic Paste", "garlic-paste", "cooking-pastes"),
  P("Ginger Paste", "ginger-paste", "cooking-pastes"),
  P("Sweet Mango Pickle", "sweet-mango-pickle", "pickles"),
  P("Red Chilli Pickle", "red-chilli-pickle", "pickles"),
  P("Mixed Pickle", "mixed-pickle", "pickles"),
  P("Mango Pickle", "mango-pickle", "pickles"),
  P("Lime Pickle", "lime-pickle", "pickles"),
  P("Kerda Pickle", "kerda-pickle", "pickles"),
  P("Gunda Pickle", "gunda-pickle", "pickles"),
  P("Green Chilli Pickle", "green-chilli-pickle", "pickles"),
  P("Garlic Pickle", "garlic-pickle", "pickles"),
  P("Mixed Fruit Jam", "mixed-fruit-jam", "fruit-jams"),
  P("Strawberry Jam", "strawberry-jam", "fruit-jams"),
  P("Apricot Jam", "apricot-jam", "fruit-jams"),
  P("Raspberry Jam", "raspberry-jam", "fruit-jams"),
  P("Orange Jam", "orange-jam", "fruit-jams"),
  P("Mango Jam", "mango-jam", "fruit-jams"),
  P("Black Currant Jam", "black-currant-jam", "fruit-jams"),
  P("Pineapple Jam", "pineapple-jam", "fruit-jams"),
];

export const RTE_PRODUCTS = PRODUCTS.filter((p) => p.category === "ready-to-eat");

export const GROUPS = [
  {
    slug: "ready-to-eat",
    name: "Ready-to-Eat / Ready-to-Cook",
    shortName: "Ready-to-Eat",
    image: img("rte-palak-paneer"),
    description:
      "Twenty authentic Indian meals — from dal makhani to vegetable biryani — in export-ready 300g and 250g packs, with private label available.",
    productLine:
      "Authentic Indian meal prepared for convenient serving and international food markets.",
    categories: ["ready-to-eat"],
  },
  {
    slug: "spices-seasonings",
    name: "Spices & Seasonings",
    shortName: "Spices",
    image: img("turmeric-powder"),
    description:
      "Whole and ground Indian spices — dill, fennel, cinnamon and cardamom through turmeric, cumin and garam masala.",
    productLine: "Premium Indian spice, selected and packed for export markets.",
    categories: ["whole-spices", "powder-spices"],
  },
  {
    slug: "superfoods",
    name: "Superfoods & Healthy Snacks",
    shortName: "Superfoods",
    image: img("makhana"),
    description:
      "Makhana, roasted chana, almonds, cashews, raisins, pumpkin, sunflower and flax seeds.",
    productLine: "Healthy snack and superfood, packed for export markets.",
    categories: ["superfoods"],
  },
  {
    slug: "mango-pulp",
    name: "Mango Pulp",
    shortName: "Mango Pulp",
    image: img("kesar-mango-pulp"),
    description: "Kesar and Alphonso mango pulp in export-ready packaging.",
    productLine: "Premium Indian mango pulp in export packaging.",
    categories: ["mango-pulp"],
  },
  {
    slug: "cooking-pastes",
    name: "Cooking Pastes",
    shortName: "Cooking Pastes",
    image: img("ginger-garlic-paste"),
    description: "Ginger garlic, garlic and ginger pastes for retail and food service.",
    productLine: "Cooking paste prepared for retail and food-service markets.",
    categories: ["cooking-pastes"],
  },
  {
    slug: "pickles",
    name: "Pickles",
    shortName: "Pickles",
    image: img("sweet-mango-pickle"),
    description:
      "Nine authentic Indian pickle varieties — mango, lime, chilli, kerda, gunda, garlic and more.",
    productLine: "Authentic Indian pickle in export-ready jars.",
    categories: ["pickles"],
  },
  {
    slug: "fruit-jams",
    name: "Fruit Jams",
    shortName: "Fruit Jams",
    image: img("strawberry-jam"),
    description: "Eight fruit jam varieties for international retail shelves.",
    productLine: "Fruit jam in retail-ready export packaging.",
    categories: ["fruit-jams"],
  },
  {
    slug: "other-fmcg",
    name: "Other Food & FMCG Products",
    shortName: "Other FMCG",
    image: "/assets/brand/private-label.jpg",
    description:
      "Additional supermarket-ready food and FMCG products sourced to buyer requirement.",
    productLine: "",
    categories: ["other-fmcg"],
  },
];

export const groupOf = (categorySlug) =>
  GROUPS.find((g) => g.categories.includes(categorySlug));

export const productsByGroup = (group) =>
  PRODUCTS.filter((p) => group.categories.includes(p.category));
